import { ScoreData } from "entities";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import {
  Button,
  Container,
  Header,
  Icon,
  Segment,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import { Labels } from "utils/constants";

interface QuestionTableProps {
  percent?: boolean;
  data: ScoreData[];
}
export const QuestionTable = ({ percent, data }: QuestionTableProps) => {
  const [scores, setScores] = useState<ScoreData[]>([]);
  const columns = ["date", "score1", "score2", "score3", "score4", "total"];

  const csvmaker = function (data) {
    let csvRows = [];

    csvRows.push(`Date,${Labels.join(",")},Total`);
    for (const row of data) {
      const values = columns.map((e) => {
        return e === "date"
          ? DateTime.fromISO(row[e]).toFormat("y-MM-dd")
          : !percent || e === "total"
          ? row[e]
          : `${Math.round((row[e] * 100) / (row.total > 0 ? row.total : 1))}%`;
      });
      csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
  };

  const download = (data) => {
    const blob = new Blob([data], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "download.csv";
    a.click();
  };

  const exportData = () => {
    const r = csvmaker(scores);
    download(r);
  };

  const sortTable = (key: string) => {
    setScores([]);
    if (key === "date") {
      setScores([
        ...scores.sort(
          (a, b) =>
            DateTime.fromISO(b[key]).valueOf() -
            DateTime.fromISO(a[key]).valueOf()
        ),
      ]);
    } else {
      setScores([...scores.sort((a, b) => b[key] - a[key])]);
    }
  };

  useEffect(() => {
    setScores(
      data.sort(
        (a, b) =>
          DateTime.fromISO(b.date).valueOf() -
          DateTime.fromISO(a.date).valueOf()
      )
    );
  }, [data]);

  return (
    <Segment id="piechart">
      <Container clearing>
        <Header as="h3" floated="left">
          {percent
            ? "Pourcentage des réponses en vue tableau"
            : "Nombre de réponses en vue tableau"}
        </Header>
        <Container as="div" floated="right" textAlign="right">
          <Button secondary onClick={exportData}>
            Exporter
          </Button>
        </Container>
      </Container>

      <Table celled padded>
        <TableHeader>
          <TableRow>
            <TableHeaderCell singleLine onClick={() => sortTable("date")}>
              Date
            </TableHeaderCell>
            {Labels.map((lab, i) => (
              <TableHeaderCell key={i} singleLine>
                {lab}
              </TableHeaderCell>
            ))}
            <TableHeaderCell singleLine>Total</TableHeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {scores.map((score) => {
            return (
              <TableRow key={score.data_id}>
                {columns.map((column, i) => (
                  <TableCell key={`${score.data_id}-${i}`}>
                    {column === "date"
                      ? DateTime.fromISO(score[column]).toFormat("y-MM-dd")
                      : !percent || column === "total"
                      ? score[column]
                      : `${Math.round(
                          (score[column] * 100) / (score.total || 1)
                        )}%`}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}

          {data.length === 0 && (
            <TableRow style={{ height: "8rem" }}>
              <TableCell colSpan={columns.length + 1}>
                <Segment placeholder>
                  <Header icon>
                    <Icon name="ban" />
                    Il n'y a aucune donnee enregistrée pour le moment
                  </Header>
                </Segment>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Segment>
  );
};
